import React from 'react';
import PropTypes from 'prop-types';
import {Button} from 'react-bootstrap';
import HeaderLayout from '../../components/Layout/HeaderLayout';
import {LabelBar} from '../../components';
import withIntl from '../../lib/withIntl';

function TrayCalibrationHeader({onAutoCalibration, onClose, intl}) {
  return (
    <HeaderLayout className="tray-calibration-header">
      <HeaderLayout.Left>
        <div className="menu-n-title">
          <LabelBar text={intl.formatMessage({id: 'trayCalibrationContainer.title'})} className="title" />
        </div>
      </HeaderLayout.Left>
      <HeaderLayout.Right>
        <Button
          bsStyle="success"
          type="button"
          className="tray-calibration-header__button auto-calibration"
          onClick={() => onAutoCalibration([0, 1, 2, 5, 4, 3])}
        >
          {intl.formatMessage({
            id: 'trayCalibrationContainer.autoCalibrationButton',
          })}
        </Button>
        <Button type="button" className="tray-calibration-header__button cancel" onClick={onClose}>
          {intl.formatMessage({
            id: 'trayCalibrationContainer.firstButton',
          })}
        </Button>
      </HeaderLayout.Right>
    </HeaderLayout>
  );
}

export default withIntl(TrayCalibrationHeader);
TrayCalibrationHeader.propTypes = {
  onClose: PropTypes.func.isRequired,
  onAutoCalibration: PropTypes.func.isRequired,
  intl: PropTypes.any.isRequired,
};
